/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* Licensed under the MIT License. See LICENSE.md in the project root for license terms.
*--------------------------------------------------------------------------------------------*/

import { MarkerSeverity } from "monaco-editor/esm/vs/editor/editor.api";
import styles from "./DiagnosticIcon.module.css";

export interface DiagnosticIconProps {
  category: MarkerSeverity;
}

export const DiagnosticIcon = ({ category }: DiagnosticIconProps) => {

  function getIconClass(category: MarkerSeverity) {
    switch (category) {
      case MarkerSeverity.Warning:
      case MarkerSeverity.Hint:
        return `codicon codicon-warning ${styles.warning}`;
      case MarkerSeverity.Error:
        return `codicon codicon-error ${styles.error}`;
      case MarkerSeverity.Info:
        return `codicon codicon-lightbulb-autofix ${styles.info}`;
    }
  }

  return (
    <div className={styles.diagnosticIcon}>
      <div className={getIconClass(category)}>
      </div>
    </div>
  );
}
